import { observer } from "mobx-react-lite";
import { useState, useEffect } from "react";
import pageBuilderStore from "../../../stores/pageBuilderStore";
import DraggableAsset, { IImageAsset } from "../shared/draggable-asset";
import { Images } from "lucide-react";

/**
 * ImageLibrarySection displays the global image library for the user's website or project.
 * This panel allows users to browse available images and (in the future) drag-and-drop
 * images directly into their page or email designs in the PageBuilder.
 *
 * Features:
 * - Renders a grid of available images (currently placeholders).
 * - Designed for integration with drag-and-drop, enabling quick image insertion.
 * - Images shown here are part of the shared, global image set for the user's project or site.
 *
 * @component
 * @remarks
 * - Internal-use-only component for the PageBuilder's SidebarPanel, typically under the "Image Library" tab.
 * - Currently displays static placeholders; will be wired up to actual image data and drag logic as application features are implemented.
 * - Supports (or will support) uploading and managing the global image set.
 *
 * @example
 * // Used inside SidebarPanel's "Image Library" tab:
 * <ImageLibrarySection />
 */
export default observer(function ImageLibrary() {
  const assets = pageBuilderStore.getImageLibraryAssets();

	return (
    <>
      <h4 className="text-xs font-medium text-gray-700 mb-3 flex items-center">
        <Images size={14} className="mr-2" />
        Image Library
      </h4>

      <div className="grid grid-cols-2 gap-2">
        {assets.map((asset, idx) => (
          <DraggableAsset asset={asset} key={asset.url + idx}>
            <img src={asset.url}
              alt=""
              className="w-full h-full object-cover aspect-square rounded-lg border border-gray-200 shadow-sm cursor-pointer hover:ring-2 hover:ring-blue-400 transition"
            />
          </DraggableAsset>
        ))}
      </div>
    </>
  );
});